import { useCallback } from 'react';
import { useLogMarketAnalyticsEvent } from '../../../hooks/useLogMarketAnalyticsEvent';

export const useLogClickSort = () => {
  const logMarketAnalytics = useLogMarketAnalyticsEvent();

  return useCallback<(sort: string) => void>(
    value => {
      logMarketAnalytics({
        name: 'CLICK_SORT',
        channel: ['ablylog', 'amplitude', 'facebook'],
        analytics: {
          SORT_TYPE: value,
        },
      });
    },
    [logMarketAnalytics],
  );
};
